import { type Html, html, rune, View } from 'rune-ts';
import klass from './MainSection.module.scss';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { htmlIf } from '@services/MarppleShop/shared/util';

export class MainSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const banner_url = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2025/6/original/eb388e02fce85246697f1a7fba0d9299a3a06adc1.mp4'
      : '//s3.marpple.co/files/u_4648126/2025/6/original/7d844336751f4f8cb17d2acab8a62817f8fc22b01.mp4';
    const banner_title_url = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2025/6/original/47ee1df37ddd89a19a15d9db869d63f3d3a75e4b4.png'
      : '//s3.marpple.co/files/u_4648126/2025/6/original/1354c66336a4252d3fef67c98e4125c6147988c92.png';
    const banner_sub_title_url = is_mobile
      ? '//s3.marpple.co/files/u_4648126/2025/6/original/c5926b0aa278566e7d4c9fe9af0ef75b95138e0a3.png'
      : '//s3.marpple.co/files/u_4648126/2025/6/original/f7e64160e2d5ede3ca9d976d13702a83963353c31.png';
    return html`
      <section class="${klass.container}">
        <video
          autoplay=""
          loop=""
          muted=""
          playsinline=""
          class="${klass.motion_video}"
          src="${banner_url}"
        ></video>
        <div class="${klass.content}">
          <div class="${klass.title_wrapper}">
            <img
              src="${getResizedUrl({
                url: banner_title_url,
                width: 400 * 2,
                quality: 85,
                format: 'webp',
              })}"
              class="${klass.title}"
              alt="메인 타이틀"
            />
            <img
              src="${getResizedUrl({
                url: banner_sub_title_url,
                width: 400 * 2,
                quality: 85,
                format: 'webp',
              })}"
              class="${klass.sub_title}"
              alt="서브 타이틀"
            />
          </div>
          ${is_mobile
            ? html`
                <div class="${klass.button_wrapper}">
                  <div class="${klass.button}">
                    <a
                      href="https://tally.so/r/3xBxgy"
                      target="_blank"
                      class="${klass.apply_button} goods_partners__apply_button_top"
                    >
                      <div class="${font('28_bold', '16_bold')}">크리에이터예요</div>
                    </a>
                    <div class="${klass.button_desc} ${font('14_bold')}">직접 지원할래요</div>
                  </div>
                  <div class="${klass.button}">
                    <a
                      href="https://tally.so/r/w2gGqV"
                      target="_blank"
                      class="${klass.apply_button} goods_partners__recommend_button_top"
                    >
                      <div class="${font('28_bold', '16_bold')}">팬이에요</div>
                    </a>
                    <div class="${klass.button_desc} ${font('14_bold')}">크리에이터를 추천할래요</div>
                  </div>
                </div>
              `
            : html`
                <div class="${klass.button_wrapper}">
                  <a
                    href="https://tally.so/r/3xBxgy"
                    target="_blank"
                    class="${klass.apply_button} goods_partners__apply_button_top"
                  >
                    <div class="${font('28_bold', '16_bold')}">크리에이터예요</div>
                    <div class="${font('14_bold')}">직접 지원할래요</div>
                  </a>
                  <a
                    href="https://tally.so/r/w2gGqV"
                    target="_blank"
                    class="${klass.apply_button} goods_partners__recommend_button_top"
                  >
                    <div class="${font('28_bold', '16_bold')}">팬이에요</div>
                    <div class="${font('14_bold')}">크리에이터를 추천할래요</div>
                  </a>
                </div>
              `}
        </div>
        ${htmlIf(
          html`<img
            src="${getResizedUrl({
              url: '//s3.marpple.co/files/u_4648126/2025/6/original/4d5722d5b05f613cb3dc6a4af6f4bbbcf616da311.png',
              width: 200 * 2,
              quality: 85,
              format: 'webp',
            })}"
            class="${klass.badge}"
            alt="이미지 뱃지"
          />`,
          !is_mobile,
        )}
      </section>
    `;
  }

  override onRender() {
    this.delegate('click', '.goods_partners__apply_button_top', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '상단버튼클릭_버튜버', { event_category: '상단버튼클릭_버튜버' });
      }
    });

    this.delegate('click', '.goods_partners__apply_button_top', () => {
      if (typeof window.gtag == 'function' && G.collabo_type == 'creator') {
        window.gtag('event', '상단버튼클릭_팬', { event_category: '상단버튼클릭_팬' });
      }
    });
  }
}
